const dateFormatter = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric'
});

export default function createArticleCard(
  data,
  tagName = 'li',
  className = 'article-card',
  headlineTagName = 'h2'
) {
  if (!data?.headline || !data?.url) return null;

  const { headline, url, image, tags, postDate, timeToRead } = data;

  // Wrapper
  const wrapper = document.createElement(tagName);
  wrapper.className = className;

  // Thumbnail
  if (image) {
    const imgLink = document.createElement('a');
    imgLink.className = 'article-thumb';
    imgLink.href = url;

    const img = document.createElement('img');
    img.src = image;
    img.alt = '';

    imgLink.append(img);
    wrapper.append(imgLink);
  }

  // Tags
  if (Array.isArray(tags) && tags.length) {
    const tagsList = document.createElement('ul');
    tagsList.className = 'article-tags';

    tags.forEach(tag => {
      if (!tag.name) return;

      const tagWrapper = document.createElement('li');

      const tagEl = document.createElement(tag.url ? 'a' : 'span');
      tagEl.className = 'tag';
      tagEl.innerText = tag.name;

      if (tag.url) tagEl.href = tag.url;
      if (tag.isMainCategory) tagEl.classList.add('primary');
      if (tag.isHighlighted) tagEl.classList.add('highlight');

      tagWrapper.append(tagEl);
      tagsList.append(tagWrapper);
    });

    wrapper.append(tagsList);
  }

  // Headline
  const headlineLink = document.createElement('a');
  headlineLink.href = url;

  const headlineEl = document.createElement(headlineTagName);
  headlineEl.innerText = headline;

  headlineLink.append(headlineEl);
  wrapper.append(headlineLink);

  // Metadata
  const date = !postDate ? null : new Date(postDate);
  const hasDate = date && !isNaN(date) && date.getFullYear() > 1970;

  if (hasDate || timeToRead) {
    const meta = document.createElement('div');
    meta.className = 'article-meta';

    if (hasDate) {
      const dateEl = document.createElement('time');
      dateEl.dateTime = date.toISOString();
      dateEl.innerText = dateFormatter.format(date);

      meta.append(dateEl);
    }

    if (timeToRead) {
      const timeToReadEl = document.createElement('span');
      timeToReadEl.innerText = `${timeToRead} min read`;

      meta.append(timeToReadEl);
    }

    wrapper.append(meta);
  }

  return wrapper;
}
